import { createContext } from 'react';

/**
 * Context for the advisor dataset.
 */
export var AdvisorContext = /*#__PURE__*/createContext({});